export default "__VITE_ASSET__7f15ce33__"